<template>

    <v-flex xs12 sm10 offset-sm1 md8 offset-md2 lg6 offset-lg3>
        <!-- Alert -->
        <Alert v-if="alertType !== ''" :atype="alertType" :message="message" :visibility="visibility" />

        <v-progress-linear v-if="progressbar" :indeterminate="true"></v-progress-linear>

        <v-flex v-if="content" xs12 sm10 offset-sm1 md10 offset-md1>

            <v-container fluid class="semi-transparent-5-bg">

                <img v-if="content.type == 'Image'" :src="content.value" width="100%;" height="auto"/>

                <div v-else v-html="content.value" style="overflow:auto; margin:auto"></div>

            </v-container>

        </v-flex>

    </v-flex>

</template>


<script>
import Alert from "@/components/Reusable/Alert.vue";
import Api from "@/api";

export default {
    data() {
        return {
            progressbar: false,
            alertType: "",
            message: "",
            visibility: "",
            content: ""
        }
    },
    components: {
        Alert
    },
    methods: {
        async getHow2Win() {

            this.progressbar = true;

            let res = await Api.getPage({
                name:'t1_frontend_page_how2win'
            });

            if (res && 'success' in res && res.success === true) {

                this.content = res.data;

            } else {

                this.visibility = true;

                this.message = res.message;

                this.alertType = "error";

            }

            this.progressbar = false;

        }

    },
    mounted: async function() {

        await this.getHow2Win();

    }

}
</script>